import { customSearch } from '@vindr/utils/helpers/common.helper';
import { ConfigProvider, Row, Select } from 'antd';
import { SelectProps } from 'antd/lib/select';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

interface SelectFilter extends SelectProps {
  title: string | boolean;
  searchVietnamese?: boolean;
  width?: number | string;
  wrapperClassName?: string;
  className?: string;
}

const SelectFilter = ({
  title,
  onChange,
  mode,
  allowClear = true,
  onSearch,
  searchVietnamese,
  width = 200,
  wrapperClassName,
  className,
  showSearch = true,
  ...props
}: SelectFilter) => {
  const { t } = useTranslation('Vindoc');
  const [open, setOpen] = useState(false);

  return (
    <div className={wrapperClassName} style={{ width, maxWidth: '100%' }}>
      {typeof title === 'string' && <Row className="filter-title pb-1 pt-[6px]">{title}</Row>}

      <ConfigProvider renderEmpty={() => ''}>
        <Select
          size="small"
          onDropdownVisibleChange={(visible) => setOpen(visible)}
          style={{ width: '100%' }}
          {...{
            showSearch,
            className,
            allowClear,
            open,
            filterOption: (input, option) => customSearch(input, option, searchVietnamese, t),
          }}
          {...(mode && { mode })}
          {...(onSearch && { onSearch })}
          onChange={(...args) => {
            if (window.innerWidth < 640) {
              setOpen(false);
            }
            onChange?.(...args);
          }}
          maxTagCount="responsive"
          maxTagPlaceholder={(omittedValues) => `+ ${omittedValues.length} ${t('more')}`}
          {...props}
        />
      </ConfigProvider>
    </div>
  );
};

export default SelectFilter;
